import { RootState } from "../rootStore";

export const selectClinicList = ({ clinic }: RootState) => clinic.clinicList;

export const selectClinicUserList = ({ clinic }: RootState) =>
  clinic.clinicUserList;

export const selectClinicHasMore = ({ clinic }: RootState) => {
  return clinic.total > clinic.offset + clinic.limit;
};

export const selectSortConfig = ({ clinic }: RootState) => clinic.sortConfig;

export const selectLoading = ({ clinic }: RootState) => clinic.loading;

export const selectClinicCurrentPage = ({ clinic }: RootState) =>
  clinic.limit > 0 ? Math.floor(clinic.offset / clinic.limit) + 1 : 1;

export const selectClinicTotalPages = ({ clinic }: RootState) =>
  clinic.limit > 0 ? Math.ceil(clinic.total / clinic.limit) : 1;
